<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title class="text-h4 primary--text">
          Cuestionario INDRE
          <v-spacer> </v-spacer>

          <v-btn @click.prevent="prellenar" icon color="primary">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
              Ocupación:
            </v-flex>
            <v-flex xs12 md5 class="pr-5">
              <v-text-field
                :readonly="soloLectura"
                :rules="[() => valor.Ocupacion != null || 'Campo requerido']"
                v-model="valor.Ocupacion"
                hide-details="auto"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
              1) ¿Realizó algún viaje en los últimos 14 días?
            </v-flex>
            <v-flex xs12 md5 class="pr-5">
              <v-radio-group
                :readonly="soloLectura"
                row
                :rules="[
                  () => valor.AlgunViaje14Dias != null || 'Campo requerido',
                ]"
                v-model="valor.AlgunViaje14Dias"
              >
                <v-radio label="SI" :value="true"></v-radio>
                <v-radio label="NO" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12>
              <v-card color="gris">
                <v-card-text class="gris">
                  <v-layout row wrap>
                    <v-flex xs12 class="primary--text">
                      ¿Y en los últimos 14 días:
                    </v-flex>
                    <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
                      2) ha tenido contacto cercano con una persona con sospecha
                      de tener SARS-CoV2?
                    </v-flex>
                    <v-flex xs12 md5 class="pr-5">
                      <v-radio-group
                        :readonly="soloLectura"
                        row
                        :rules="[
                          () =>
                            valor.ContactoPersonaSospechosa != null ||
                            'Campo requerido',
                        ]"
                        v-model="valor.ContactoPersonaSospechosa"
                      >
                        <v-radio label="SI" :value="true"></v-radio>
                        <v-radio label="NO" :value="false"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
                      3) ha tenido contacto cercano con una persona confirmada
                      por laboratorio para SARS-CoV2?
                    </v-flex>
                    <v-flex xs12 md5 class="pr-5">
                      <v-radio-group
                        :readonly="soloLectura"
                        row
                        :rules="[
                          () =>
                            valor.ContactoPersonaConfirmada != null ||
                            'Campo requerido',
                        ]"
                        v-model="valor.ContactoPersonaConfirmada"
                      >
                        <v-radio label="SI" :value="true"></v-radio>
                        <v-radio label="NO" :value="false"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
              4) ¿En los últimos 14 días ha presentado signos y/o síntomas
              sospechosos de COVID-19?
            </v-flex>
            <v-flex xs12 md5 class="pr-5">
              <v-radio-group
                :readonly="soloLectura"
                row
                :rules="[
                  () => valor.PresentaSintomas != null || 'Campo requerido',
                ]"
                v-model="valor.PresentaSintomas"
              >
                <v-radio label="SI" :value="true"></v-radio>
                <v-radio
                  label="NO"
                  :value="false"
                  @click.native="valor.FechaInicioSintomas = ''"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
              5) Si es así, ¿Cuál fue la fecha de inicio?
            </v-flex>
            <v-flex xs12 md5 class="pr-5">
              <datepicker2
                :readonly="soloLectura || !valor.PresentaSintomas"
                v-model="valor.FechaInicioSintomas"
              ></datepicker2>
            </v-flex>
            <v-flex xs12 class="text-h5 pt-4 pl-5">
              6) De la siguiente tabla seleccione cuáles:
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex
                  xs3
                  class="text-h5 pt-4 pl-5 primary--text text-center font-weight-bold"
                >
                  PRINCIPALES
                </v-flex>
                <v-flex xs3 class="text-h5 pt-4 pl-5 primary--text text-center">
                  OTROS
                </v-flex>
                <v-flex xs3 class="text-h5 pt-4 pl-5 primary--text text-center">
                  OTROS
                </v-flex>
                <v-flex xs3 class="text-h5 pt-4 pl-5 primary--text text-center">
                  OTROS
                </v-flex>
                <v-flex xs3 class="font-weight-bold pl-4">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Fiebre"
                    v-model="valor.Fiebre"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Dolor de cabeza"
                    v-model="valor.DolorCabeza"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Calosfríos"
                    v-model="valor.CalosFrios"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Dolor muscular"
                    v-model="valor.DolorMuscular"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="font-weight-bold pl-4">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Tos"
                    v-model="valor.Tos"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Irritabilidad"
                    v-model="valor.Irritabilidad"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Dolor abdominal"
                    v-model="valor.DolorAbdominal"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Dolor en articulaciones"
                    v-model="valor.DolorArticulaciones"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="font-weight-bold pl-4">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Dolor torácico"
                    v-model="valor.DolorToracico"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Diarrea"
                    v-model="valor.Diarrea"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Dolor al pasar alimentos"
                    v-model="valor.DolorPasarAlimentos"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Congestión nasal"
                    v-model="valor.CongestionNasal"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="font-weight-bold pl-4">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Dificultad respiratoria"
                    v-model="valor.DificultadRespiratoria"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Vómito"
                    v-model="valor.Vomito"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Convulsiones"
                    v-model="valor.Convulsiones"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Respiración rápida"
                    v-model="valor.RespiracionRapida"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="font-weight-bold pl-4"> </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Dolor de cuerpo"
                    v-model="valor.DolorCuerpo"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Uñas moradas"
                    v-model="valor.UnasMoradas"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs3 class="">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Infección en los ojos"
                    v-model="valor.InfeccionOjos"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2 class="text-h5 pt-4 pl-5">
                  Otros:
                </v-flex>
                <v-flex xs12 md10>
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="valor.Otros"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
              7) ¿Está recibiendo tratamiento con medicamentos?
            </v-flex>
            <v-flex xs12 md5 class="pr-5">
              <v-radio-group
                :readonly="soloLectura"
                row
                :rules="[
                  () =>
                    valor.RecibeTratamientoMedico != null || 'Campo requerido',
                ]"
                v-model="valor.RecibeTratamientoMedico"
              >
                <v-radio label="SI" :value="true"></v-radio>
                <v-radio label="NO" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
              8) ¿Qué está tomando?
            </v-flex>
            <v-flex xs12 md5 class="pr-5">
              <v-text-field
                :readonly="soloLectura"
                v-model="valor.QueTratamiento"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
              9) ¿Alguna persona con las que convive regularmente presenta
              sintomas?
            </v-flex>
            <v-flex xs12 md5 class="pr-5">
              <v-radio-group
                :readonly="soloLectura"
                row
                :rules="[
                  () =>
                    valor.PersonasConviveConSintomas != null ||
                    'Campo requerido',
                ]"
                v-model="valor.PersonasConviveConSintomas"
              >
                <v-radio label="SI" :value="true"></v-radio>
                <v-radio label="NO" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 v-if="valor.PersonasConviveConSintomas == 1">
              <v-layout row>
                <v-flex xs2 class="text-left primary--text text-h4">
                  Nombre(s)
                </v-flex>
                <v-flex xs2 class="text-left primary--text text-h4">
                  1er Apellido
                </v-flex>
                <v-flex xs2 class="text-left primary--text text-h4">
                  2do Apellido
                </v-flex>
                <v-flex xs2 class="text-left primary--text text-h4">
                  Genero
                </v-flex>
                <v-flex xs1 class="text-left primary--text text-h4">
                  Edad
                </v-flex>
                <v-flex xs1 class="text-left primary--text text-h4 pl-3">
                  ¿Vive con usted?
                </v-flex>
                <v-flex xs2 class="text-left primary--text text-h4">
                  ¿Cuáles síntomas?
                </v-flex>
              </v-layout>
              <v-layout row v-for="(persona, i) in valor.Personas" :key="i">
                <v-flex xs2 class="text-left primary--text text-h4">
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="persona.Nombre"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="text-left primary--text text-h4">
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="persona.PrimerApellido"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="text-left primary--text text-h4">
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="persona.SegundoApellido"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="text-left primary--text text-h4">
                  <v-autocomplete
                    :readonly="soloLectura"
                    :items="catalogos.Generos"
                    item-text="Genero"
                    item-value="GeneroID"
                    v-model="persona.GeneroID"
                    outlined
                    hide-details="auto"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs1 class="text-left primary--text text-h4">
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="persona.Edad"
                    type="number"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="text-left primary--text text-h4 pl-3">
                  <v-radio-group
                    :readonly="soloLectura"
                    row
                    v-model="persona.ViveConUsted"
                  >
                    <v-radio label="SI" :value="true"></v-radio>
                    <v-radio label="NO" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs2 class="text-left primary--text text-h4">
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="persona.Sintomas"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 class="text-right">
                  <v-btn @click.prevent="agregarPersona"
                    ><v-icon>add</v-icon> Agregar persona</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 md7 class="text-h5 pt-4 pl-5">
              Comentarios adicionales
            </v-flex>
            <v-flex xs12 md5 class="pr-5">
              <v-textarea
                rows="4"
                v-model="valor.ComentariosAdicionales"
                hide-details="auto"
                outlined
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import datepicker2 from '../components/DatePicker2';
export default {
  props: ['value', 'catalogos', 'soloLectura'],
  name: 'indre',
  components: {datepicker2},
  data() {
    return {
      valor: {Personas: []},
      personas: [{}],
    };
  },
  methods: {
    agregarPersona() {
      this.valor.Personas.push({});
    },
    prellenar() {
      this.$set(this.valor, 'Ocupacion', 'No Especificado');
      this.$set(this.valor, 'AlgunViaje14Dias', false);
      this.$set(this.valor, 'ContactoPersonaSospechosa', false);
      this.$set(this.valor, 'ContactoPersonaConfirmada', false);
      this.$set(this.valor, 'PresentaSintomas', false);
      this.$set(this.valor, 'RecibeTratamientoMedico', false);
      this.$set(this.valor, 'PersonasConviveConSintomas', false);
    },
  },
  mounted() {
    this.valor = this.value || {Personas: [], Ocupacion: '', Otros: ''};
  },
  watch: {
    valor: {
      deep: true,
      handler() {
        this.$emit('input', this.valor);
      },
    },
    value() {
      if (this.value) {
        this.valor = this.value;
      }
    },
  },
};
</script>

<style></style>
